import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  openRequestSupport: () => void
}
export default function InvestmentPreferenceHeaderSection({
  openRequestSupport,
}: Props) {
  return (
    <PDSFlexBox marginTop={SIZE.s32} flexDirection="column">
      <PDSFlexBox alignItems="center" justifyContent="space-between">
        <PDSHeader variant="h1" marginBottom={SIZE.s8}>
          Investment Preferences
        </PDSHeader>

        <PDSBox flexShrink={0}>
          <PDSButton
            iconLeft="support"
            onClick={openRequestSupport}
            size="sm"
            text="Request Support"
            variant="tertiary"
          />
        </PDSBox>
      </PDSFlexBox>
      <PDSText variant="p" fontSize={FONT_SIZE.xs}>
        Set your investment preferences to align with your strategy,
        constraints, and goals.
      </PDSText>
    </PDSFlexBox>
  )
}
